<template>
    <div class="information-overlay" :class="{ active: status }" ref="informationOverlay">
        <div class="description">
            <EnterSvg v-if="status === 'enter-join'" />
            <EnterSvg v-if="status === 'enter-create'" />
            <div class="material-icons" v-if="status === 'inactive'">block</div>
            <div class="material-icons" v-if="status === 'deactive-user'">chat</div>
            <span>{{ statusText[status] }}</span>
        </div>
        <div v-if="channelStatus">
            <SupsisButton @click="clickButton" v-if="['enter-join', 'enter-create'].includes(status)" primary>
                {{ joinText() }}
            </SupsisButton>
        </div>
        <SupsisButton @click="sendTemplateMessage" v-if="['deactive-user'].includes(status) && isWhatsapp()" primary>
            {{ $t('message.sendTemplateMessage') }}
        </SupsisButton>
        <SupsisButton @click="startWhatsappChat"
            v-if="['enter-create'].includes(status) && isWhatsapp() && whatsappChannels.length > 1" primary>
            {{ $t('message.startChatWithDifferentChannel') }}
        </SupsisButton>
        <Modal2 v-if="showWhatsappChatStarterModal" :show-footer="false" class="modal-wp-chat-starter"
            :title="$t('message.whatsappChatStarter')" @cancel="() => (showWhatsappChatStarterModal = false)">
            <WhatsappChatStarter :default-phone-number="contact.whatsappNumber" channel-override phone-number-override
                @close="() => (showWhatsappChatStarterModal = false)" :default-email="contact.email"
                :default-name="contact.name || contact.fullname" />
        </Modal2>
    </div>
</template>

<script>
import { log2 } from "../../../../../utils/log2";
import { mapActions, mapState } from "vuex";
import EnterSvg from "../../svg/EnterSvg.vue";
import SupsisButton from "../../../../../views/Pages/Settings/components/SupsisButton.vue";
import Modal2 from "../../../../common/Modal2.vue";
import WhatsappChatStarter from "../../../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import _ from "lodash";

const log = log2("InformationOverlay");
export default {
    name: "InformationOverlay",
    components: { WhatsappChatStarter, Modal2, SupsisButton, EnterSvg },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        status: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState({
            whatsappChannels: (state) => state.channel.channels.filter((x) => x.type.startsWith("whatsapp")),
            departments: (state) => state.subject.subjects.data,
        }),
        channelStatus() {
            if (this.contact.platform === "whatsapp") {
                return this.whatsappChannels.some((channel) => channel._id === this.contact.channel);
            }
            return true;
        },
        statusText() {
            return {
                "enter-join": this.$t('message.pressEnterToJoin'),
                "enter-create": this.$t('message.pressEnterToStartChat'),
                "inactive": this.$t('message.cannotSendMessage'),
                "deactive-user": this.$t('message.cannotSendSessionMessage'),
            }
        }
    },

    data: () => ({
        handleEnterKey: null,
        showWhatsappChatStarterModal: false,
    }),
    mounted() {
        this.$emit("blur-editor");
        this.handleEnterKey = (e) => {
            const isInput = _.get(e, "target.nodeName") === "INPUT";
            const isTextArea = _.get(e, "target.nodeName") === "TEXTAREA";
            const editableContent = !!e?.target?.getAttribute("contenteditable");
            if (isInput || isTextArea || editableContent) {
                return;
            }
            if (e.key === "Enter" && this.status === "enter-join") {
                this.clickButton();
            } else if (e.key === "Enter" && this.status === "enter-create") {
                this.clickButton();
            }
        };
        document.addEventListener("keydown", this.handleEnterKey);
    },
    methods: {
        ...mapActions({
            joinContactConversation: "chat/joinContactConversation",
            startChat: "chat/startChat",
        }),
        joinText() {
            if (this.status === "enter-join") {
                const isChatbot = _.get(this.contact, "lastConversation.status") === "chatbot";
                return isChatbot ? this.$t("message.takeControlFromChatbot") : this.$t("message.joinChat");
            } else if (this.status === "enter-create") {
                return this.$t("wp.startChatWp");
            }
        },
        sendTemplateMessage() {
            this.$emit("send-template-message");
        },
        clickButton() {
            if (this.status === "enter-join") {
                const lastConversationDepartment = _.get(this.contact, "lastConversation.subject");
                let myDepartments = this.$store.state.auth.user?.subjects || [];
                if (Array.isArray(myDepartments) && myDepartments.length === 0) {
                    myDepartments = this.departments.map((x) => x._id);
                }
                myDepartments = myDepartments.map((x) => (typeof x === "string" ? x : x._id));
                const departmentForceEnabled = !!this.$store.state.setting?.settings?.subject;
                console.log("department debug", {
                    departmentForceEnabled,
                    lastConversationDepartment,
                    myDepartments,
                    allDepartments: this.departments,
                    authUser: this.$store.state.auth.user,
                });
                if (
                    departmentForceEnabled &&
                    lastConversationDepartment &&
                    !myDepartments.includes(lastConversationDepartment) &&
                    myDepartments.length > 0
                ) {
                    this.$message.error(this.$t('message.conversationNotInYourDepartments'));
                    return;
                }
                this.joinContactConversation(this.contact);
            } else if (this.status === "enter-create") {
                this.startChat(this.contact);
            }
            this.$emit("focus-editor");
        },
        isWhatsapp() {
            return ["whatsapp", "meta-leads"].includes(this.contact?.platform);
        },
        startWhatsappChat() {
            if (this.contact.whatsappNumber) {
                this.showWhatsappChatStarterModal = true;
            } else {
                this.$message.error(this.$t('message.phoneNumberNotAvailable'));
            }
        },
    },
    beforeDestroy() {
        if (this.handleEnterKey) {
            document.removeEventListener("keydown", this.handleEnterKey);
        }
    },
};
</script>
<style lang="scss">
.information-overlay {
    &.active {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.63);
        z-index: 4;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 18px;
        color: black;
        justify-content: center;
        flex-direction: column;

        .description {
            display: flex;
            align-items: center;
            gap: 4px;
            justify-content: center;
        }
    }
}
</style>
